import React, { useEffect, useState } from 'react';
import { notify } from '../../services/store/states';
import './style.scss';
const Notify = () => {
    const [show, setShow] = useState(false);
    const [data, setData] = useState({});

    useEffect(() => {
        notify.subscribe(d => {
            setData(d);
            setShow(true);
        })
    }, []);

    return (
        <div>
            {show &&
                <div className='err-notify'>
                    <div className='icon'><i className='pi pi-check'></i></div>
                    <div className='content'>Notification message</div>
                    <div className='icon-close'><i className='pi pi-times' onClick={() => setShow(false)}></i></div>
                </div>
            }
        </div>

    )
}

export default Notify